import Navbar from "../components/navbar";
import { useRef, useState, useEffect } from "react";
import Aos from "aos";
import FonSideBar from "../components/fonnSideBar";
import { Icon } from "@iconify/react";
import introCartoon from "../media/readKid.avif";
import "aos/dist/aos.css";
import { motion } from "motion/react";
import dummyAva from "../media/robotKids.avif"
import useFirebaseStore from "../store/firebasestore";
import spongebob from "../media/spongebob.avif"
import { useNavigate } from "react-router-dom";
import sonic from "../media/sonic.avif"
import Swal from "sweetalert2";
import moana from "../media/moana.avif"
import Cart from "../components/cart";
import { doc } from "firebase/firestore";
import { updateDoc } from "firebase/firestore";
import { db } from "../firebase/firebaseConfig";
import sadRobot from "../media/sadRobot.jpg"
import unicorn from "../media/unicorn.avif"
import Loader from "./loader";
import dragon from "../media/dragon.avif"
import mario from "../media/mario.avif"
import cat from "../media/cat.avif"
import frozen from "../media/frozen.avif"
import "../css/branding.css"
import noavatar from "../media/noiMG.png"
import useGenStore from "../store/genstore";
import { useParams } from "react-router-dom";

function BrandingEdit() {
    const [stickerIndex, setSi] = useState(8)
  const cartView = useGenStore((s) => s.cartView)
  const [count, setCount] = useState(30);
  const navigate = useNavigate()
  const [batchSize, setBatchSize] = useState(0)

  const setFonView = useGenStore((s) => s.setFonView)
  const { cartItemID } = useParams()

  const authStatus = useFirebaseStore((s) => s.authStatus)
  const userID = useFirebaseStore((s) => s.userID)
  const cartItemsFromStore = useFirebaseStore((s) => s.cartItems)

  const cartItems =
    authStatus === "authenticated"
      ? cartItemsFromStore
      : JSON.parse(localStorage.getItem("guestCartItems") || "[]")

  const [activeCard, setActiveCard] = useState(0)
  const cartItem = cartItems.find((ci) => ci.id === cartItemID)
  const [studentName, setStudentname] = useState("")
  const [labelType, setLabelType] = useState("")

  // ❌ REMOVED the redirect guard — guests allowed now

  useEffect(() => {
    if (labelType === "Iron-on Label") {
      setBatchSize(30); setCount(30)
    }
    if (labelType === "Stick-on Label") {
      setBatchSize(30); setCount(30)
    }
    if (labelType === "Iron-on (30) & Stick-on (60) Combo") {
      setBatchSize(60); setCount(60)
    }
    if (labelType === "") {
      setBatchSize(0); setCount(0)
    }
  }, [labelType])

  const increase = () => setCount(prev => prev + batchSize);
  const decrease = () => setCount(prev => Math.max(batchSize, prev - batchSize));

  useEffect(() => {
    Aos.init({ duration: 1000 });
  }, []);

  useEffect(() => {
    if (cartItem) {
      setCount(cartItem.count);
      setSi(cartItem.stickerIndex);
      setStudentname(cartItem.studentName);
      setLabelType(cartItem.labelType);
    }
  }, [cartItem]);

  const stickerArray = [
    { avatarImg: spongebob, avatarName: "Sponge Bob", index: 0 },
    { avatarImg: sonic, avatarName: "Sonic", index: 1 },
    { avatarImg: moana, avatarName: "Mirabel", index: 2 },
    { avatarImg: dragon, avatarName: "Dinosaur", index: 3 },
    { avatarImg: mario, avatarName: "Super Mario", index: 4 },
    { avatarImg: cat, avatarName: "Bluey", index: 5 },
    { avatarImg: frozen, avatarName: "Elsa", index: 6 },
    { avatarImg: unicorn, avatarName: "Unicorn", index: 7 },
    { avatarImg: noavatar, avatarName: "No Avatar", index: 8 },
  ]

  const chooseAv = (index) => setSi(index)

  // ✅ PROPER FUNCTION — wrapped, async, with sltSticker and costPerBatch defined
  const addtoCart = async () => {
    const sltSticker =
      stickerIndex !== undefined && stickerArray[stickerIndex]
        ? stickerArray[stickerIndex].avatarName
        : undefined;

    if (!studentName || !labelType) {
      Swal.fire({
        text: "Please fill in all the fields.",
        imageUrl: sadRobot,
        imageWidth: 150,
        imageHeight: 150,
        imageAlt: "Error icon",
      });
      return;
    }

    if (!sltSticker) {
      Swal.fire({
        text: "Please select an avatar.",
        imageUrl: sadRobot,
        imageWidth: 150,
        imageHeight: 150,
        imageAlt: "Error icon",
      });
      return;
    }

    let costPerBatch = 0;
    let batchSz = 0;
    if (labelType === "Iron-on Label") {
      costPerBatch = 1100; batchSz = 30;
    } else if (labelType === "Stick-on Label") {
      costPerBatch = 1300; batchSz = 30;
    } else if (labelType === "Iron-on (30) & Stick-on (30) Combo") {
      costPerBatch = 2000; batchSz = 60;
    }

    const updatedCartItems = cartItems.map(item =>
      item.id === cartItemID
        ? { ...item, studentName, labelType, count, sltSticker, stickerIndex, costPerBatch, batchSize: batchSz }
        : item
    );

    // ✅ GUEST — localStorage
    if (authStatus !== "authenticated" || !userID) {
      localStorage.setItem("guestCartItems", JSON.stringify(updatedCartItems));
      useFirebaseStore.setState({ cartItems: updatedCartItems });

      Swal.fire("", "Item updated successfully!", "success").then(() => {
        setActiveCard(0);
      });
      return;
    }

    // ✅ SIGNED IN — Firestore
    const userRef = doc(db, "Users", userID);
    await updateDoc(userRef, { cartItems: updatedCartItems });

    Swal.fire("", "Item updated successfully!", "success").then(() => {
      setActiveCard(0);
    });
  };


  return (
    <>
    {!cartItem ? (<Loader/>):(<>   <div className={`floatCart ${cartView ? "floatCartActive" : ""}`}>
        <Cart />
      </div>
          <FonSideBar />

       <div className="Branding">
      <Navbar />
      <div className="brandingPlacer">
        <div className="brandingCard brandingCard1">
          <div className="bcCont">
            <div className="brandingCardIntro">
              <img src={introCartoon} alt="" />
              <div className="brandingCardIntroCont">
                <h3>Create Your Label</h3>
                <p>You are almost there.</p>
              </div>
            </div>
            <div className="labelMainContGen">
              {activeCard == 0 ? ( 
                <div className="labelInputs">
                <div className="labelInput">
                  <p>Students Name:</p>
                  <div className="labelInpuWrap">
                 <input
  value={studentName}
  onChange={(e)=>setStudentname(e.target.value)}
  type="text"
  placeholder="Enter Name"
/>
                  </div>
                </div>

                <div className="labelInput">
                  <p>Label Type:</p>
                  <div className="labelInpuWrap">
                     <select
                    value={labelType}
                    onChange={(e)=>setLabelType(e.target.value)}
                  >
                    <option value="">Select Label</option>
                    <option value="Iron-on Label">Iron-on Label</option>
                    <option value="Stick-on Label">Stick-on Label</option>
                    <option value="Iron-on (30) & Stick-on (30) Combo">Iron-on & Stick-on Combo</option>
                  </select>
                  </div>
                </div>
                <div className="labelBtnWrap">
                  <motion.button
                    whileHover={{ scale: 1.05 }}
                    whileTap={{ scale: 0.8 }}
                    onClick={()=>{
                       setFonView(false)
                      navigate("/")
                    }
                    }
                    className="secBtn"
                  >
                    Cancel
                  </motion.button>
                  <motion.button
                    whileHover={{ scale: 1.05 }}
                    whileTap={{ scale: 0.8 }}
                    onClick={()=>setActiveCard(1)}

                    className="priBtn"
                  >
                    Next
                  </motion.button>
                </div>
              </div>):(
<div className="selectAvator">
                <div className="selectActAvatar">
                    <div className="selectedAvatar">
                            {stickerIndex == 8 ? ( <div className="circle-containerA boyContainer">
  <div className="circle-maskA">
    <img src={dummyAva} alt="person" className="person-imgA" />
  </div>
  <img src={dummyAva} alt="person" className="person-topA" />
</div>):( <div className="circle-containerA ">
  <div className="circle-maskA ">
    <img src={stickerArray[stickerIndex].avatarImg} alt="person" className="person-imgA" />
  </div>
  <img src={stickerArray[stickerIndex].avatarImg} alt="person" className="person-topA" />
</div>)}

            
                    </div>
                  <p>Select Avatar</p>

                  <div className="AvatarsWrap">
                    {stickerArray.map((sticker, index)=>(
<motion.div 
                    key={index}
                    whileHover={{ scale: 1.05 }}
                    whileTap={{ scale: 0.8 }}
                    onClick={() => chooseAv(index)}
                    className="avatarCard">
                      <div className="avImg">
                            <img src={sticker.avatarImg} alt="" />
                      </div>
                      <span>{sticker.avatarName}</span>
                    </motion.div>
                    )

                    )}
                    
                 
                  </div>
                </div>
                <div className="labelQuantity">
                  <p>How many pieces? {labelType === "Iron-on (30) & Stick-on (30) Combo" && <span>Iron-on (30) & Stick-on (30)</span> }</p>
               <div className="lQInputWrap">
      <div className="lqLeftIcon" onClick={decrease}>
        <Icon
          className="faIcon"
          icon="solar:minus-circle-line-duotone"
        />
      </div>

      <div className="lqMidNumber">
        <p>{count}</p>
      </div>

      <div className="lqRightIcon" onClick={increase}>
        <Icon
          className="faIcon"
          icon="solar:add-circle-line-duotone"
        />
      </div>
    </div>
              </div>
                    <div className="labelBtnWrap">
                  <motion.button
                    whileHover={{ scale: 1.05 }}
                    whileTap={{ scale: 0.8 }}
                    onClick={()=>setActiveCard(0)}
                    className="secBtn"
                  >
                    Back
                  </motion.button>
                  <motion.button
                    whileHover={{ scale: 1.05 }}
                    whileTap={{ scale: 0.8 }}
                    className="priBtn"
                    onClick={addtoCart}
                  >
                    Add to Cart
                  </motion.button>
                </div>
              </div>
              )}
                          
            </div>
          </div>
        </div>
      </div>
    </div></>)}

    </>
   
  );
}

export default BrandingEdit;
